import React, { type PropsWithChildren, useContext } from "react";
import { twMerge } from "tailwind-merge";

import { Context } from "../context";

interface AccordionDetailsProps {
  className?: string;
}

const COLORS = {
  primary: "[&.active]:bg-primary-25 text-neutral-800",
  success: "bg-success-25 text-success-950",
  error: "bg-error-25 text-error-950",
  info: "bg-info-25 text-info-950",
  warning: "bg-warning-25 text-warning-950",
};

export function SupAccordionValidation({ className, children }: PropsWithChildren<AccordionDetailsProps>) {
  const { expanded, variant } = useContext(Context);

  return <div className={twMerge("sup-accordion-validation transition-colors", variant && COLORS[variant], expanded && "active", className)}>{children}</div>;
}
